import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/src/ScrollTrigger';
import { CSSRulePlugin } from 'gsap/src/CSSRulePlugin';
import { SplitText } from 'gsap/src/SplitText';

import { headerToggle } from './homeAnimations';
gsap.registerPlugin(ScrollTrigger, CSSRulePlugin, SplitText);

// Function to limit repeated code //

const statementFunc = (target, start, end, spacing) => {
  gsap.to(target, {
    scrollTrigger: {
      trigger: target,
      start: start,
      end: end,
      scrub: true,
      pin: true,
      pinSpacing: spacing,
    },
    opacity: 1,
  });
};

export const aboutTopText = () => {
  const target = document.querySelector('[data-scrolling="about-top"]');
  if (!target) {
    return;
  }
  gsap.to('[data-scrolling="about-top"] .scrolling-text__title-1', {
    scrollTrigger: {
      trigger: '[data-scrolling="about-top"] .scrolling-text__title-1',
      end: '480%',
      start: 'top 5%',
      pin: true,
      // markers: true,
      pinSpacing: false,
    },
  });
  gsap.set('[data-scrolling="about-top"] [data-statement="1"]', {
    opacity: 0,
  });

  statementFunc(
    '[data-scrolling="about-top"] [data-statement="1"]',
    'top 35%',
    '200%',
    true,
  );
  statementFunc(
    '[data-scrolling="about-top"] [data-statement="2"]',
    'top 5%',
    '100%',
    true,
  );
};

export const aboutBottomText = () => {
  const target = document.querySelector('[data-scrolling="about-bottom"]');
  if (!target) {
    return;
  }

  gsap.set('[data-scrolling="about-bottom"] [data-statement="1"]', {
    opacity: 0,
  });

  statementFunc(
    '[data-scrolling="about-bottom"] [data-statement="1"]',
    'top 40%',
    '100%',
    true,
  );
  statementFunc(
    '[data-scrolling="about-bottom"] [data-statement="2"]',
    'top 10%',
    '400%',
    false,
  );
  statementFunc(
    '[data-scrolling="about-bottom"] [data-statement="3"]',
    'top 25%',
    '300%',
    false,
  );
  statementFunc(
    '[data-scrolling="about-bottom"] [data-statement="4"]',
    'top 45%',
    '200%',
    false,
  );
  statementFunc(
    '[data-scrolling="about-bottom"] [data-statement="5"]',
    'top 65%',
    '100%',
    false,
  );

  const dots = gsap.utils.toArray('[data-dots]');
  dots.forEach((dot) => {
    gsap.to(dot, {
      scrollTrigger: {
        trigger: dot,
        start: 'top 10%',
        end: '+=4700',
        scrub: true,
        pinSpacing: false,
        pin: true,
      },
    });
  });
};

export const meetSquad = () => {
  const target = document.querySelector('.meet-the-squad');
  if (!target) {
    return;
  }
  // const squadTitleSplit = new SplitText('.meet-the-squad__title', {
  //   type: 'words',
  // });
  // const squadTitleWords = squadTitleSplit.words;
  // gsap.to(squadTitleWords, { y: -80, stagger: 1 });
  const title = document.querySelector('.meet-the-squad__title');
  gsap.to(title, {
    scrollTrigger: {
      trigger: '.meet-the-squad',
      start: 'top 55%',
      end: '+=7000',
      scrub: true,
    },
    y: -800,
  });
};

export const aboutTextBottom = () => {
  const target = document.querySelector('[data-scrolling="about-alt"]');
  if (!target) {
    return;
  }

  gsap.to('.scrolling-text__title-2', {
    scrollTrigger: {
      trigger: '.scrolling-text__title-2',
      end: '+=3700',
      start: 'center 12%',
      pin: true,
      pinSpacing: false,
    },
  });

  // // Mobile Sizes for animations
  // let title2Start;
  // if (window.matchMedia('(min-width: 768px)').matches) {
  //   title2Start = 'top -10%';
  // } else {
  //   title2Start = 'top -15%';
  // }

  // gsap.to('.scrolling-text__title-2', {
  //   scrollTrigger: {
  //     trigger: '.scrolling-text__title-2',
  //     end: '+=3700',
  //     start: title2Start,
  //     pin: true,
  //     markers: true,
  //     pinSpacing: false,
  //   },
  // });

  // const dots = gsap.utils.toArray('[data-dots]');
  // dots.forEach((dot) => {
  //   gsap.to(dot, {
  //     scrollTrigger: {
  //       trigger: dot,
  //       start: 'top 10%',
  //       end: '+=3700',
  //       scrub: true,
  //       pinSpacing: false,
  //       pin: true,
  //     },
  //   });
  // });

  // Mobile Sizes for animations
  let start1, start2, start3;
  if (window.matchMedia('(min-width: 768px)').matches) {
    start1 = 'top 20%';
    start2 = 'top 35%';
    start3 = 'top 50%';
  } else {
    start1 = 'top 25%';
    start2 = 'top 37%';
    start3 = 'top 50%';
  }

  // First Headline //

  // ScrollTrigger.create({
  //   trigger: '[data-scrolling="about-alt"] [data-statement="1"]',
  //   start: start1,
  //   // scrub: true,
  //   pin: true,
  //   pinSpacing: false,
  //   end: '2000%',
  // });

  // ScrollTrigger.create({
  //   trigger: '[data-scrolling="about-alt"] [data-statement="2"]',
  //   start: 'top 30%',
  //   scrub: true,
  //   pin: true,
  //   pinSpacing: true,
  //   end: '200%',
  // });

  // ScrollTrigger.create({
  //   trigger: '[data-scrolling="about-alt"] [data-statement="3"]',
  //   start: start2,
  //   scrub: true,
  //   pin: true,
  //   pinSpacing: false,
  //   end: '1200%',
  // });
  // ScrollTrigger.create({
  //   trigger: '[data-scrolling="about-alt"] [data-statement="4"]',
  //   start: 'top 45%',
  //   scrub: true,
  //   pin: true,
  //   pinSpacing: true,
  //   end: '200%',
  // });
  // ScrollTrigger.create({
  //   trigger: '[data-scrolling="about-alt"] [data-statement="5"]',
  //   start: start3,
  //   scrub: true,
  //   pin: true,
  //   pinSpacing: false,
  //   end: '700%',
  // });
  // ScrollTrigger.create({
  //   trigger: '[data-scrolling="about-alt"] [data-statement="6"]',
  //   start: 'top 65%',
  //   scrub: true,
  //   pin: true,
  //   pinSpacing: true,
  //   end: '200%',
  // });

  const tl = gsap.timeline();

  tl.to('[data-scrolling="about-alt"] [data-statement="1"]', {
    scrollTrigger: {
      trigger: '[data-scrolling="about-alt"] [data-statement="1"]',
      start: start1,
      // scrub: true,
      pin: true,
      pinSpacing: false,
      end: '2000%',
    },
  });

  tl.fromTo(
    '[data-scrolling="about-alt"] [data-statement="2"]',
    {
      opacity: 1,
      y: 40,
    },
    {
      scrollTrigger: {
        trigger: '[data-scrolling="about-alt"] [data-statement="2"]',
        start: 'top 35%',
        end: '100%',
        scrub: true,
        pin: true,

        pinSpacing: true,
      },
      opacity: 0,
      y: 0,
    },
  );

  tl.to('[data-scrolling="about-alt"] [data-statement="3"]', {
    scrollTrigger: {
      trigger: '[data-scrolling="about-alt"] [data-statement="3"]',
      start: start2,
      // scrub: true,
      pin: true,
      pinSpacing: false,
      end: '1200%',
    },
  });

  tl.fromTo(
    '[data-scrolling="about-alt"] [data-statement="4"]',
    {
      opacity: 1,
      y: 40,
    },
    {
      scrollTrigger: {
        trigger: '[data-scrolling="about-alt"] [data-statement="4"]',
        start: 'top 50%',
        end: '100%',
        scrub: true,
        pin: true,

        pinSpacing: true,
      },
      opacity: 0,
      y: 0,
    },
  );

  tl.to('[data-scrolling="about-alt"] [data-statement="5"]', {
    scrollTrigger: {
      trigger: '[data-scrolling="about-alt"] [data-statement="5"]',
      start: start3,
      // scrub: true,
      pin: true,
      pinSpacing: false,
      end: '1200%',
    },
  });

  tl.fromTo(
    '[data-scrolling="about-alt"] [data-statement="6"]',
    {
      opacity: 1,
      y: 40,
    },
    {
      scrollTrigger: {
        trigger: '[data-scrolling="about-alt"] [data-statement="6"]',
        start: 'top 65%',
        end: '100%',
        scrub: true,
        pin: true,

        pinSpacing: true,
      },
      opacity: 0,
      y: 0,
    },
  );

  // // Control each of the home page byline statements in the bottom section of the page //
  // const homeStatementFunc = (target, start, end, spacing) => {
  //   gsap.fromTo(
  //     target,
  //     {
  //       opacity: 1,
  //       y: 40,
  //     },
  //     {
  //       scrollTrigger: {
  //         trigger: target,
  //         start: start,
  //         end: end,
  //         scrub: true,
  //         pin: true,
  //         pinSpacing: spacing,
  //       },
  //       opacity: 0,
  //       y: 0,
  //     },
  //   );
  // };

  // homeStatementFunc('[data-statement="2"]', 'top 15%', '100%', false);
  // homeStatementFunc('[data-statement="4"]', 'top 20%', '100%', false);
  // homeStatementFunc('[data-statement="6"]', 'top 25%', '100%', false);
};
